module.exports = __webpack_public_path__ + "static/media/_DSF6925.b76008e5.jpg";